'use client';

import Image from 'next/image';

import BiodermaLogo from '@/fo/icons/base/logos/bioderma.svg';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './Results.styles';

const GALCHONOK_LOGO = staticMediaUrl(
  'landing/bioderma_galchonok/logo-galchonok.png?w=750'
);

function Stat({ value, label }: { value: string; label: string }) {
  const slots = styles();

  return (
    <div className={slots.stat()}>
      <p className={slots.statValue()}>{value}</p>
      <p className={slots.statLabel()}>{label}</p>
    </div>
  );
}

function Logos() {
  const slots = styles();

  return (
    <div className={slots.logos()}>
      <Image
        className={slots.galchonokLogo()}
        src={GALCHONOK_LOGO}
        alt="Галчонок"
        width={174}
        height={140}
      />
      <span className={slots.cross()}>×</span>
      <BiodermaLogo className={slots.biodermaLogo()} />
    </div>
  );
}

export function Results({ className }: { className?: string }) {
  const slots = styles();

  return (
    <section
      className={slots.base({ className })}
      id="results"
    >
      <div className={slots.grid()}>
        <div className={`${slots.card()} ${slots.cardLogos()}`}>
          <Logos />
        </div>
        <div className={`${slots.card()} ${slots.cardStat()}`}>
          <Stat
            value="6 ЛЕТ"
            label="сотрудничества"
          />
        </div>
        <div
          className={`${slots.card()} ${slots.cardStat()} ${slots.cardWide()}`}
        >
          <Stat
            value="300 семьям"
            label="была оказана помощь"
          />
        </div>
      </div>
    </section>
  );
}
